/**
 * @fileoverview The photo door of Today's start card, "A photo of anything"
 * (B96: the one photo door, in place of the packets and growing doors): the
 * photo picker, opened on Today (B30, design revision 4), and the photos
 * reviewed in "Check and save" over Today (D78 decision 3), never a trip to
 * the Photos tab.
 *
 * It is the add pop-ups' photo path (features/add-by-photo usePhotoAdd): the
 * same PhotoSourcePicker the add pop-ups open (camera, this device, Google Photos;
 * several at once), the photos put on the tray one at a time underneath
 * (grouped by day, the photo guess for paid plans; on Free nothing is read and
 * the sheet says so once), and the sheet over Today with this batch's piles.
 * Closing the sheet keeps the unfiled photos on the tray, for the Photos page.
 * An exact copy of a photo already added is skipped, "Already added" with Undo
 * (B61). A Google Photos pick that comes back after the picker closed is the
 * tray's (kind 'tray'), delivered by the app's frame, so Today never takes a
 * photo held for a bed's seed-packet scan.
 *
 * TodayPage owns this hook and draws its element once, outside the views, so
 * the picker and the sheet are not unmounted when the doors give way to Today
 * on the first plant (design rev 3).
 *
 * Where: TodayPage, for WelcomePlace's photo door.
 * API: the photo path's (usePhotoAdd: POST /tray, the tray's guess and
 * filing).
 * Words (en/es): the photo path's (add.photo, review.*).
 *
 * @module useDoorPhotos
 */

import type React from 'react';
import { usePhotoAdd } from '@/features/add-by-photo/usePhotoAdd';

/** What the hook hands back. */
export interface DoorPhotosControl {
  /** Opens the photo picker. */
  open: () => void;
  /** The picker and "Check and save": render it once, anywhere. */
  element: React.ReactNode;
}

/**
 * The photo picker for the photo door, and the sheet its photos are reviewed in.
 *
 * @returns open(), and the element to render once.
 */
export function useDoorPhotos(): DoorPhotosControl {
  const photoAdd = usePhotoAdd();
  return { open: photoAdd.start, element: photoAdd.element };
}
